var _defs, _g, _g2;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function Svg404(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 736 500",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, ".cls-1{fill:#fff;}.cls-2{fill:#002e4f;}.cls-3{fill:#e0c1c1;}.cls-4{fill:#e1f3f6;}.cls-5,.cls-6{fill:#e9b925;}.cls-5{opacity:0.61;}.cls-7{fill:#212020;}.cls-8{fill:#514f4f;}.cls-13,.cls-14,.cls-9{fill:none;stroke-miterlimit:10;}.cls-9{stroke:#20c6f0;stroke-linecap:round;stroke-width:7.65px;}.cls-10{fill:#cde5e8;}.cls-11{fill:#f6ee9e;}.cls-12{fill:#f8fdff;}.cls-13,.cls-14{stroke:#dddd67;}.cls-13{stroke-width:0.87px;}.cls-14{stroke-width:0.75px;}.cls-15{fill:#00a4e2;}.cls-16{fill:#0086cf;}"))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "BACKGROUND"
  }, /*#__PURE__*/React.createElement("rect", {
    className: "cls-1",
    x: 186,
    width: 500,
    height: 500
  }))), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", {
    id: "OBJECTS"
  }, /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M382.85,407.34c-5.28,6.84-11.48,11.93-10.12,14.24,0,0,2.81,2,10.56,2,13.29,0,26.35-1,24.2-2.36-3-1.87-11.57-2.54-19.79-5.39-2-.7,4.44-4.64,2.67-5.28A40,40,0,0,1,382.85,407.34Z",
    transform: "translate(186)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M519.75,421.17s1.75,2.45,8.45,2.45c11.49,0,23.46-1.56,21.61-2.73-2.57-1.61-22.71-5.81-22.71-5.81l-4.51-5.61-7.66,4.24Z",
    transform: "translate(186)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-3",
    d: "M483.35,251.85a61.91,61.91,0,0,1-15-1.79,8.07,8.07,0,0,1,4.22-15.58c.28.08,18.43,4.73,29-4.36,7.08-6.09,9.78-17.54,8-34.06l-.57-5.27,16.32-9.24a8.07,8.07,0,0,1,7.95,14l-7.21,4.08c1.14,19.46-3.59,33.83-14.08,42.77C503.16,250,492.12,251.85,483.35,251.85Z",
    transform: "translate(186)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-4",
    d: "M511.27,207.08c-.3,11.73-3.42,20.22-9.34,25.3-11.61,10-31.51,4.88-31.85,4.79a8.86,8.86,0,0,0-4.64,17.1,39.13,39.13,0,0,0,16.46,3.25c34.33-1.22,55.05-30.83,55.43-48.09Z",
    transform: "translate(186)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-5",
    d: "M464.07,166c-3.07-1.38-6.09-2.87-9.07-4.44-28.44,16.2-64.78,36.95-65.5,37.67,0,0,18.06,28.76,19.21,29.91.74.74,45.53-31.38,77.75-54.66C479,171.62,471.36,169.28,464.07,166Z",
    transform: "translate(186)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-5",
    d: "M464.54,165.19c7.45,3.29,15.27,5.67,22.84,8.65C505.12,161,518.83,151,518.83,151l-30.31-8.52S473.93,150.8,456,161Q460.18,163.25,464.54,165.19Z",
    transform: "translate(186)"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-6",
    points: "598.27 127.44 616.12 175.76 651.02 188.57 606.82 107.82 598.27 127.44"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-6",
    points: "652.92 200.44 627.07 200.44 650.08 240.64 685.16 255.43 652.92 200.44"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-6",
    d: "M499.16,255.43l-20.59-35.11-88.05,51.62L373.21,242.4,384.08,66.8l39.57-23.2,71.22,121.49,24-14.05,19.93,34-24,14.05,20.58,35.11ZM419.28,119.17l-2.23,1.31L411,214.26l47.65-27.94Z",
    transform: "translate(186)"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-5",
    points: "529.94 234.36 559.21 242.4 576.52 271.94 545.6 264.1 529.94 234.36"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-5",
    points: "529.94 234.36 559.21 242.4 570.08 66.8 543.23 60.37 529.94 234.36"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-5",
    points: "543.23 60.37 570.08 66.8 609.65 43.6 582.46 35.69 543.23 60.37"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-7",
    d: "M416.11,304.34s4.31,46.4,4.31,62.66c0,0-33.79,26.34-42.07,40.11,3.56,2.71,10.58,6.3,15.18,6.16a329.26,329.26,0,0,1,47.29-36.9s10.68-31,14-57.18Z",
    transform: "translate(186)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-4",
    d: "M440.2,306.53c7.61.05,15.38-1.26,21.93-4.81-2.2-9.27,2.48-36.61,8.35-51.22,0,0,4.64-10.17,1.39-13.3-12-11.56-22.25-10.61-25.43-10.74-11,9.31-31.56,36.8-30.74,73.12C421.37,305.54,432.88,306.48,440.2,306.53Z",
    transform: "translate(186)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-8",
    d: "M514.73,415c4.4-1.22,8.62-3.25,11.33-6.85-13-21.16-60.9-98.89-63.49-105-.06-.15-.12-.33-.18-.51-7,3.79-15.42,5.12-23.54,4.81-7.08-.27-17.33-1.27-23.11-6.51l0,1.13c1,20.29,68.31,87.93,94.79,113.8A33.28,33.28,0,0,0,514.73,415Z",
    transform: "translate(186)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-3",
    d: "M375.8,285.49a17,17,0,0,1-5.38-.84c-3.56-1.19-8.26-4.19-10.49-11.69a8.07,8.07,0,1,1,15.47-4.59,5.26,5.26,0,0,0,.39,1c.86,0,4-.24,11.83-4.81,6.95-4.08,15.17-10.16,23.12-16,13.43-9.94,26.11-19.32,36.59-22.64a8.07,8.07,0,0,1,4.87,15.38c-7.92,2.51-20.09,11.52-31.87,20.23C403.09,274.24,387.89,285.49,375.8,285.49Z",
    transform: "translate(186)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-3",
    d: "M390.89,279.46c-1-4.75-2-10-5-13.9-6.5,3.6-9.28,3.84-10.07,3.81a5.26,5.26,0,0,1-.39-1A8.07,8.07,0,1,0,359.93,273c2.23,7.5,6.93,10.5,10.49,11.69a17,17,0,0,0,5.38.84c4.69,0,9.84-1.7,15.41-4.51C391.1,280.47,391,280,390.89,279.46Z",
    transform: "translate(186)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-4",
    d: "M457.45,231.14a8.07,8.07,0,0,0-10.12-5.26c-10.48,3.32-23.16,12.7-36.59,22.64-7.95,5.88-16.17,12-23.12,16l-.92.53c3,4,8.24,23.64,8.33,24.09,8.55-4.48,49.59-35.72,58.48-45.15C456.57,240.79,458.8,235.39,457.45,231.14Z",
    transform: "translate(186)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-9",
    d: "M354.38,264.1",
    transform: "translate(186)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-3",
    d: "M364.39,279a2.36,2.36,0,0,1-1.38-.44c-6.33-4.52-9.63-13.23-9.77-13.6a2.37,2.37,0,0,1,4.45-1.66h0c0,.08,2.95,7.73,8.08,11.4a2.37,2.37,0,0,1-1.38,4.3Z",
    transform: "translate(186)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-3",
    d: "M364.39,273.19a2.35,2.35,0,0,1-1.93-1c-3-4.29-5.46-14.48-5.73-15.62a2.38,2.38,0,0,1,4.63-1.08c.67,2.87,2.86,11,5,14a2.36,2.36,0,0,1-.57,3.3A2.31,2.31,0,0,1,364.39,273.19Z",
    transform: "translate(186)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-3",
    d: "M367.67,271.85a2.36,2.36,0,0,1-2.2-1.47c-2.17-5.33-3-16.51-3.06-17a2.38,2.38,0,0,1,4.74-.35c.22,3,1.14,11.69,2.71,15.54a2.36,2.36,0,0,1-1.3,3.09A2.31,2.31,0,0,1,367.67,271.85Z",
    transform: "translate(186)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-3",
    d: "M371.23,270.71a2.38,2.38,0,0,1-2.3-1.78,27.9,27.9,0,0,1-.07-11.95,2.37,2.37,0,1,1,4.62,1.08,23.26,23.26,0,0,0,0,9.69,2.38,2.38,0,0,1-1.71,2.89A2.44,2.44,0,0,1,371.23,270.71Z",
    transform: "translate(186)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-3",
    d: "M466.62,244a7.58,7.58,0,0,1-6.86-10.83,45.73,45.73,0,0,1,5.64-8.48A7.59,7.59,0,0,1,477,234.51h0a30.24,30.24,0,0,0-3.52,5.18A7.6,7.6,0,0,1,466.62,244Z",
    transform: "translate(186)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-3",
    d: "M467.72,240.13a39.34,39.34,0,0,0,2.82,2.81,7.52,7.52,0,0,0,2.95-3.25,30.24,30.24,0,0,1,3.52-5.18,7.59,7.59,0,0,0-11.61-9.79c-.15.18-.77.92-1.58,2C463.89,231.5,464.39,236.47,467.72,240.13Z",
    transform: "translate(186)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-3",
    d: "M492.65,231.75a14.35,14.35,0,0,1-18.74,7.8h0a14.35,14.35,0,0,1-7.8-18.74l3.8-9.21a14.35,14.35,0,0,1,18.74-7.81h0a14.37,14.37,0,0,1,7.8,18.75Z",
    transform: "translate(186)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-7",
    d: "M467.71,219.74c-1.16,4.93-8.25,3.35-10.91.77-3.67-3.55-5.85-13.58,2.27-13-5.85-8.84,14-18.41,16.08-8.21,1.55-2.63,3.13-5,6.58-5.22,2.49-.16,6.84,1.77,6.48,4.81a10.29,10.29,0,0,1,12.72.26c1.17.94,3.27,3,2.22,4.57-.58.85-3.57,1.11-4.57,1.41,1.72-.78,8.8.8,7.4,3.73-.64,1.38-4.1.14-5.12-.15,0,0,0,.32,0,.31,3.78,2.07,5.34,4.17,4.88,8.87-.2,2.17-1.23,6.25-3.8,6.56-1.32.15-2.84-.68-2.81-2.06,3.15,3.15-1.32,11.59-5.3,7.43-1.57-1.63-.81-4.37.67-5.78-2.36-1.35-7.47-8.52-3.83-10.44-1.7,0-9.58-2.63-7.07-4.89.66,2.63-2.59,6-5.18,4.68,1.61,3.5-3.13,6.11-6,6.24,1.78,2.24-3.7,4.9-5.38,1.65Z",
    transform: "translate(186)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-3",
    d: "M198,191.08s-4.6-17.63,18.25-21.83l-1.74,21.2Z",
    transform: "translate(186)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-10",
    d: "M106.42,235.62a32.23,32.23,0,0,1-14-3C71.71,222.77,69.4,193.29,69.32,192a8.07,8.07,0,0,1,16.09-1.15c.45,5.93,3.84,22.35,14,27.12,8.38,3.93,21.38-.07,37.6-11.59a8.06,8.06,0,1,1,9.34,13.15C131.3,230.25,117.94,235.62,106.42,235.62Z",
    transform: "translate(186)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-5",
    d: "M149.35,250.76c2.24-5.89,4.32-11.87,6.74-17.69a48,48,0,0,1-5-.65,40.48,40.48,0,0,1-19.88-9.56,48.14,48.14,0,0,1-12.57-18.51,79.78,79.78,0,0,1-5.16-25.48,126.16,126.16,0,0,1,2.3-30.15,125.71,125.71,0,0,1,9-29A80.1,80.1,0,0,1,139,98.07a48.19,48.19,0,0,1,18.52-12.58,42.63,42.63,0,0,1,38.4,5.42c2.29-4.56,4.74-9,7.08-13.51,2.77-5.29,5.34-10.67,7.79-16.1,1.05-2.32,2-4.72,2.92-7.09A86.06,86.06,0,0,0,187,44.6q-20.94-4-39.42,1.51a88.39,88.39,0,0,0-33.29,18.47A112,112,0,0,0,89.19,97.1a155.76,155.76,0,0,0-14.92,43.68A155.65,155.65,0,0,0,72,186.89,112,112,0,0,0,83.4,226.38a88.52,88.52,0,0,0,24.14,29.44,81.33,81.33,0,0,0,33.24,15.35C143.8,264.43,146.72,257.66,149.35,250.76Z",
    transform: "translate(186)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-5",
    d: "M258.61,129.47A112.25,112.25,0,0,0,247.24,90a88.55,88.55,0,0,0-24.13-29.43,76.29,76.29,0,0,0-8.58-5.85c-.95,2.37-1.85,4.76-2.92,7.07-2.5,5.42-5,10.82-7.79,16.1-2.36,4.5-4.84,9-7.14,13.61.82.62,1.61,1.27,2.39,2A49.9,49.9,0,0,1,211.8,112a77.55,77.55,0,0,1,5.35,25.35,126.53,126.53,0,0,1-2.33,30.3,126.25,126.25,0,0,1-9,28.87,77.79,77.79,0,0,1-14.35,21.76,49.79,49.79,0,0,1-18.67,12.54,38.76,38.76,0,0,1-15.76,2.34c-2.68,6.37-4.94,12.93-7.39,19.38s-5.14,12.63-8,18.85l1.9.39q20.94,4,39.42-1.52a88.48,88.48,0,0,0,33.28-18.46,111.74,111.74,0,0,0,25.12-32.53,155.55,155.55,0,0,0,14.93-43.68A155.91,155.91,0,0,0,258.61,129.47Z",
    transform: "translate(186)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-6",
    d: "M168.28,280.13q-20.94-4-36.09-15.93a88.37,88.37,0,0,1-24.13-29.44,111.78,111.78,0,0,1-11.37-39.49,155.65,155.65,0,0,1,2.23-46.11,155.76,155.76,0,0,1,14.92-43.68A112.17,112.17,0,0,1,139,73a88.46,88.46,0,0,1,33.29-18.47Q190.73,49,211.67,53t36.09,15.93a88.57,88.57,0,0,1,24.13,29.44,112,112,0,0,1,11.37,39.5A155.91,155.91,0,0,1,281,184a156.29,156.29,0,0,1-14.92,43.68A111.76,111.76,0,0,1,241,260.15a88.29,88.29,0,0,1-33.28,18.47Q189.21,284.13,168.28,280.13Zm7.51-39.34a39.77,39.77,0,0,0,21.68-1.61,49.75,49.75,0,0,0,18.68-12.54,77.79,77.79,0,0,0,14.35-21.76,126.25,126.25,0,0,0,9-28.87,126.05,126.05,0,0,0,2.33-30.3,77.49,77.49,0,0,0-5.35-25.35,49.74,49.74,0,0,0-12.73-18.55,39.85,39.85,0,0,0-19.56-9.49,40.38,40.38,0,0,0-22,1.55,48.19,48.19,0,0,0-18.52,12.58,80.1,80.1,0,0,0-14.16,21.63,125.56,125.56,0,0,0-9,29,126.12,126.12,0,0,0-2.3,30.14,79.84,79.84,0,0,0,5.16,25.49,48.14,48.14,0,0,0,12.57,18.51A40.34,40.34,0,0,0,175.79,240.79Z",
    transform: "translate(186)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-7",
    d: "M310.59,161.67l.62,29.66s-8.47,7.59-16.06,0l2.8-33.4Z",
    transform: "translate(186)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M275.66,398.25c-.48-.38-3.79-1.92-4.25-2.3a39,39,0,0,1-5.15,6.33,10.71,10.71,0,0,1,3.89,10.09,43.51,43.51,0,0,1-5.15,3.9c-4.61,2.28-13.12,5.43-13.12,5.43l21.43,1.68,15.9-16.28A100.74,100.74,0,0,1,275.66,398.25Z",
    transform: "translate(186)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M191.69,399.41c-3.41-.59-7.72,2-10.5,0a71.64,71.64,0,0,0-.52,9.22L149,421.7h40.5c.36-4.31-.41-8.45.17-12.45C189.93,407.19,191.32,401.39,191.69,399.41Z",
    transform: "translate(186)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-10",
    d: "M228.6,255.5l-35.83,68.08s14.52,12.28,28.82,16.37l26.86-80.21Z",
    transform: "translate(186)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-7",
    d: "M267.84,404a50.78,50.78,0,0,0,5.69-7.48c-9.27-7.94-13.8-16.13-26.4-30.21-5.21-5.83,8.59-39.22,11.95-44.82,6-10.06,6.95-17.35,11.66-34.58l-35,13.08c-8.33,29.83-18,59.67-8.3,73.91,10.28,15.05,28.53,27.17,37.33,33.22C265.11,407.33,267.54,403.76,267.84,404Z",
    transform: "translate(186)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-3",
    d: "M208.92,187.58a2.33,2.33,0,0,1-1.38-.44,2.37,2.37,0,0,1-.55-3.31,20.24,20.24,0,0,0,3.45-7.2,2.37,2.37,0,0,1,4.67.82,24.43,24.43,0,0,1-4.26,9.14A2.37,2.37,0,0,1,208.92,187.58Z",
    transform: "translate(186)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-11",
    d: "M268.25,294.11c10.42-28.6,19.31-73.48,22.64-91.39a44.88,44.88,0,0,0-5.14-1.75c-3.09-.86-6.79-1.86-10-.88a19.18,19.18,0,0,0-4.44,2.21,51.84,51.84,0,0,0-1.84,7.17s-22.37,42.77-36.94,71.93A145.64,145.64,0,0,1,268.25,294.11Z",
    transform: "translate(186)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-8",
    d: "M232.15,282.28h0c-1.29,2.59-2.52,5.06-3.66,7.38h0c-2.86,5.08-6,9.78-9,14.29-28.79,43.41-39.66,78-41.58,94.38,2.75,2.14,13.14,3.36,16.61,4,5.31-27.14,19.13-44.47,43.89-64.94,8.29-6.85,14.49-15.55,19.94-22.78,3.24-4.3,6.46-11.21,9.56-19.57A145.28,145.28,0,0,0,232.15,282.28Z",
    transform: "translate(186)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-3",
    d: "M204.21,294.22a8.07,8.07,0,0,1-2.64-15.69c9.78-3.39,24.79-16.77,34.92-31.13,20.54-29.12,35-45.27,35.56-45.94a8.07,8.07,0,1,1,12,10.77h0c-.14.16-14.45,16.19-34.39,44.47-10,14.17-27.65,31.81-42.82,37.07A8.09,8.09,0,0,1,204.21,294.22Z",
    transform: "translate(186)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-3",
    d: "M285.23,205.4l-.57,0a7.58,7.58,0,0,1-7-8.12,45.82,45.82,0,0,1,2.2-9.94,7.59,7.59,0,0,1,14.36,4.95,29.92,29.92,0,0,0-1.42,6.09A7.6,7.6,0,0,1,285.23,205.4Z",
    transform: "translate(186)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-3",
    d: "M287.45,197.39a35,35,0,0,0,4.36,4.17,7.73,7.73,0,0,0,1-3.21,29.92,29.92,0,0,1,1.42-6.09,7.59,7.59,0,0,0-13.41-6.8C281.5,189.74,285,194.58,287.45,197.39Z",
    transform: "translate(186)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-3",
    d: "M307,181a14.36,14.36,0,0,1-14.67,14h0a14.36,14.36,0,0,1-14-14.68l.22-10a14.36,14.36,0,0,1,14.68-14h0a14.37,14.37,0,0,1,14,14.67Z",
    transform: "translate(186)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-3",
    d: "M192.82,292a29.85,29.85,0,0,1-11.34-2.67,2.38,2.38,0,0,1,1.84-4.38c6.24,2.63,11.22,3,14.38,1.09a2.37,2.37,0,1,1,2.45,4.06A13.85,13.85,0,0,1,192.82,292Z",
    transform: "translate(186)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-3",
    d: "M195.66,295.44a40.8,40.8,0,0,1-10.25-1.57l-1.07-.25a2.37,2.37,0,0,1,1.1-4.62l1.08.26c5.76,1.39,9.56,2.32,18,.14a2.38,2.38,0,0,1,1.19,4.6A39.57,39.57,0,0,1,195.66,295.44Z",
    transform: "translate(186)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-3",
    d: "M192.65,287.32a20.28,20.28,0,0,1-12.8-4.82,2.37,2.37,0,0,1,3.2-3.5c.23.21,5.69,5,13,3.13a2.37,2.37,0,1,1,1.18,4.6A18.63,18.63,0,0,1,192.65,287.32Z",
    transform: "translate(186)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-3",
    d: "M197.63,284.77l-.28,0a15.24,15.24,0,0,1-11.5-7,2.37,2.37,0,0,1,4.15-2.3,10.56,10.56,0,0,0,7.9,4.6,2.37,2.37,0,0,1-.27,4.73Z",
    transform: "translate(186)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-3",
    d: "M226,191a2.56,2.56,0,0,1-.39,0c-3.92-.65-14.67-2.34-17.17-2.34a2.38,2.38,0,0,1,0-4.75c3.34,0,16.46,2.16,18,2.41A2.37,2.37,0,0,1,226,191Z",
    transform: "translate(186)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-3",
    d: "M224.46,196a2.21,2.21,0,0,1-.62-.09c-.12,0-11.4-3.1-16.65-3.4a2.37,2.37,0,0,1,.27-4.74c5.75.33,17.15,3.43,17.63,3.57a2.37,2.37,0,0,1-.63,4.66Z",
    transform: "translate(186)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-3",
    d: "M223.32,201.2a2.31,2.31,0,0,1-.73-.11c-10.68-3.45-13.32-3.66-14.73-3.77a10.25,10.25,0,0,1-2-.31,2.37,2.37,0,1,1,1.22-4.58,5.68,5.68,0,0,0,1.14.16c1.72.14,4.6.37,15.81,4a2.37,2.37,0,0,1-.73,4.62Z",
    transform: "translate(186)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-3",
    d: "M218.63,205h-.17c-10.7-.77-11.15-6.58-11.16-7.24l4.74-.11a.43.43,0,0,0,0-.15s.49,2.32,6.77,2.77a2.37,2.37,0,0,1-.17,4.73Z",
    transform: "translate(186)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-3",
    d: "M209.67,202.15a13.66,13.66,0,0,0-5.27-1c-2.7,0-6.37-4.58-6.37-9.33,0,0-1.31-14,13.48-7.67Z",
    transform: "translate(186)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-10",
    d: "M256.24,243.8,235.51,345.88s32.11,7.74,51.8-3.61l5-141.83S270.25,192.73,256.24,243.8Z",
    transform: "translate(186)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-4",
    d: "M261,300l19.86-1.07s.48,30.37-11.39,29.19C269.51,328.09,253.28,331.64,261,300Z",
    transform: "translate(186)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-4",
    d: "M286,198a11.87,11.87,0,0,0-16.75.91c-.61.68-15.12,16.9-35.84,46.29-1.36,1.93-2.85,3.89-4.44,5.84l-2.11,2.59,2.3,2.42c2.44,2.58,5,5.1,7.49,7.54q2,2,4,4l2.93,2.94,2.67-3.18c2.38-2.84,4.57-5.68,6.53-8.44,19.81-28.1,34-44,34.11-44.13A11.87,11.87,0,0,0,286,198Z",
    transform: "translate(186)"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-12",
    x: 231.93,
    y: 244.32,
    width: 11.99,
    height: 28.07,
    transform: "translate(72.74 262.68) rotate(-48.06)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-7",
    d: "M263.9,186.64l18.24,7.15s7.76-37.74,2.1-43.4C284.24,150.39,263.9,148.46,263.9,186.64Z",
    transform: "translate(186)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-7",
    d: "M285.29,157c.65,1,14.81,10.41,25.92,7.8,0,0-1.9-16.69-27.85-14.28Z",
    transform: "translate(186)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-13",
    d: "M296.22,174.76a7.93,7.93,0,1,1-7.93-7.93A7.93,7.93,0,0,1,296.22,174.76Z",
    transform: "translate(186)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-14",
    d: "M314.14,176.31a6.9,6.9,0,1,1-6.9-6.9A6.9,6.9,0,0,1,314.14,176.31Z",
    transform: "translate(186)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-13",
    d: "M296.22,174.76s2.64-1,4.2.54",
    transform: "translate(186)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-3",
    d: "M65.42,188.65l-.56,0a7.6,7.6,0,0,1-7-8.13,44.85,44.85,0,0,1,2.21-9.93,7.59,7.59,0,0,1,14.35,4.94,30.86,30.86,0,0,0-1.42,6.1A7.59,7.59,0,0,1,65.42,188.65Z",
    transform: "translate(186)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-7",
    d: "M60.91,399.37a62.42,62.42,0,0,0,23.73,5.8c8.2-14.59,32.9-54.1,10.43-86.53L63.28,301.56S95.07,334.72,60.91,399.37Z",
    transform: "translate(186)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M77.36,412.28s2.94-5.95,5.23-10c-1.72-.21-9.42-.52-12.58-1.73-3,6.06-9.43,14.94-14,21H98.72Z",
    transform: "translate(186)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-8",
    d: "M130.19,320.54c-5.31-10.31-43.88-41.36-47.38-59.19-.31-1.58-.57-3.2-.8-4.86-6.2,3.28-14.24,4.17-20.62,4.5-7.22.36-11.54.81-18.54-2.59.59,11.06-1.21,21.75,5.25,33,12.81,22.24,55.38,41.28,60.13,48.63,9.37,14.5,12.61,46,15.79,65.18,5,0,16.9-.22,21.79-1.95C144.16,393.37,146.83,352.84,130.19,320.54Z",
    transform: "translate(186)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M143.49,410.56s-1.39-5.62-1.8-8.24c-4.89,1.72-7.73,0-12.76,0,.76,4.77.2,13.67.64,18.89h40.49Z",
    transform: "translate(186)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-10",
    d: "M61.69,266.81c6.17-.28,19.12-2,24.32-7.2-1.06-8.46-4.85-22.08-3.52-33,4.52-37.16-13.62-48.3-13.62-48.3s-8.36-5.84-15.13,1.14c-10.2,10.51-20.16,40.24-19.16,84.19C41.61,267.23,54.3,267.15,61.69,266.81Z",
    transform: "translate(186)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-3",
    d: "M154.75,278.54a8.16,8.16,0,0,1-1.83-.21c-29.24-6.78-54-24.3-71.62-50.66-13.19-19.76-17.75-37.48-17.94-38.23A8.07,8.07,0,0,1,79,185.49a121.41,121.41,0,0,0,16,33.67c15.48,23,36.18,37.57,61.53,43.46a8.06,8.06,0,0,1-1.81,15.92Z",
    transform: "translate(186)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-4",
    d: "M137,254.3c-16.11-7.63-29.82-19.72-40.76-35.94a120.79,120.79,0,0,1-15.82-33.22A9.49,9.49,0,0,0,62,189.79l0,.18c1.25,5.43,6.24,24.53,18.1,42.28,14.2,21.26,33.47,37.18,55.72,46a1.55,1.55,0,0,0,.52.1,1.45,1.45,0,0,0,.8-.25,1.43,1.43,0,0,0,.63-1.18V255.59A1.43,1.43,0,0,0,137,254.3Z",
    transform: "translate(186)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-3",
    d: "M160.74,279.12a42,42,0,0,1-8.23-.87,2.37,2.37,0,0,1,.93-4.65c7.07,1.41,13,.89,17.52-1.54a2.37,2.37,0,0,1,2.23,4.19A26.11,26.11,0,0,1,160.74,279.12Z",
    transform: "translate(186)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-3",
    d: "M161.07,273.81a24.34,24.34,0,0,1-3.47-.25,2.38,2.38,0,1,1,.69-4.7C165.87,270,172.9,266,173,266a2.37,2.37,0,1,1,2.36,4.12A31.3,31.3,0,0,1,161.07,273.81Z",
    transform: "translate(186)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-3",
    d: "M159,269.14c-.37,0-.75,0-1.13,0a2.37,2.37,0,1,1,.3-4.73,10.74,10.74,0,0,0,8.58-3.1,2.37,2.37,0,1,1,3.69,3A15.14,15.14,0,0,1,159,269.14Z",
    transform: "translate(186)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-3",
    d: "M150.76,265.14a2.38,2.38,0,0,1,0-4.75,10,10,0,0,0,7.58-4,2.37,2.37,0,1,1,3.9,2.7C158.1,265.07,151.06,265.14,150.76,265.14Z",
    transform: "translate(186)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-3",
    d: "M143,211.58a2.37,2.37,0,0,1-1.93-1,24.44,24.44,0,0,1-4.27-9.14,2.37,2.37,0,0,1,4.68-.81,20,20,0,0,0,3.44,7.18,2.36,2.36,0,0,1-1.92,3.75Z",
    transform: "translate(186)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-3",
    d: "M143.5,212.63a2.28,2.28,0,0,1-.45,0c-5.19-1-15.49-1-15.59-1a2.37,2.37,0,1,1,0-4.74c.44,0,10.85,0,16.49,1.09a2.37,2.37,0,0,1-.45,4.7Z",
    transform: "translate(186)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-3",
    d: "M126.16,217.57a2.37,2.37,0,0,1-.29-4.72c1.5-.19,14.83-1.81,19.14-1a2.37,2.37,0,1,1-.83,4.67c-2.72-.48-12.31.41-17.73,1.08A1.46,1.46,0,0,1,126.16,217.57Z",
    transform: "translate(186)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-3",
    d: "M129.24,222.94a2.37,2.37,0,0,1-.44-4.7,67.18,67.18,0,0,0,10.06-2.5c1.3-.42,2.93-.94,5.34-1.64a2.37,2.37,0,1,1,1.32,4.56c-2.35.68-3.87,1.17-5.21,1.6a71.7,71.7,0,0,1-10.62,2.64A2.28,2.28,0,0,1,129.24,222.94Z",
    transform: "translate(186)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-3",
    d: "M134.35,226.71A2.37,2.37,0,0,1,134,222c7.68-1.32,9.21-4.18,9.22-4.21a2.37,2.37,0,0,1,4.51,1.48c-.31.92-2.36,5.6-12.93,7.41A2.83,2.83,0,0,1,134.35,226.71Z",
    transform: "translate(186)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-3",
    d: "M143.5,223.85l-1.81-19.34s8.48.62,8.46,9.51C150.15,217,149.29,220.3,143.5,223.85Z",
    transform: "translate(186)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-3",
    d: "M90.1,160.85a15.16,15.16,0,0,1-10.78,18.54h0a15.16,15.16,0,0,1-18.54-10.78l-2.69-10.18a15.16,15.16,0,0,1,10.78-18.54h0a15.16,15.16,0,0,1,18.54,10.78Z",
    transform: "translate(186)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-7",
    d: "M88.68,155.47c-1.15,3.21-2.78,6.4-5.29,8.56a22.55,22.55,0,0,1-22.89,3.53l.28,1.05a15.16,15.16,0,1,0,29.32-7.76Z",
    transform: "translate(186)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-7",
    d: "M60.73,168.05c-5.69-3.66-11.84-17.56-2.85-20.6,5.57-1.88,3.33,15.27,3.33,20.12Z",
    transform: "translate(186)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-7",
    d: "M56.16,148.59c-6.88-5,1.65-19.09,18.66-19.09,10.51,0,10.44,8.05,3.16,12.4-6,3.6-15.39,1.49-19.92,7.64Z",
    transform: "translate(186)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-7",
    d: "M88.68,158.58c-2.41-3.65-7.16-11.06-9-15.23-1.17-2.64-2.78-7.16,2.53-3.95,4.44,2.68,6.85,12.15,6.43,16.94Z",
    transform: "translate(186)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-5",
    d: "M-31.53,192.32a105.51,105.51,0,0,0-7.86,7.39l-34.25,71.54,25.5-32.91,27.08-56C-24.52,185.71-28,189.06-31.53,192.32Z",
    transform: "translate(186)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-5",
    d: "M-51.84,180.58c2.48-3.4,4.87-7.39,7.7-10.9l-59.95-29.27L-161,146.1l99.66,46C-58,188.33-54.75,184.56-51.84,180.58Z",
    transform: "translate(186)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-5",
    d: "M-43.28,170.09c-3.19,4-5.78,8.68-8.84,12.41-2.74,3.34-5.5,6.68-8.32,10l45.31,20.89L1.32,191.87Z",
    transform: "translate(186)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-6",
    d: "M-111.51,253.12l17.57-36.71L-186,172.34l14.78-30.88L-19.61,52.18,21.76,72-39,199l25,12-17,35.54-25.06-12-17.57,36.71Zm68.2-142.46-2.33-1.11L-126.74,157l49.82,23.85Z",
    transform: "translate(186)"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-6",
    points: "172 211 187.32 191.87 175.3 218.53 154.42 247.69 172 211"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-6",
    d: "M-19.86,181.3l59.78-131L21.76,72-39,199C-37.36,197.37-20.83,182.26-19.86,181.3Z",
    transform: "translate(186)"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-5",
    points: "14.79 141.46 41.8 117.95 189.93 32.92 166.39 52.18 14.79 141.46"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-5",
    points: "166.39 52.18 207.76 71.98 225.92 50.24 189.93 32.92 166.39 52.18"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-3",
    d: "M-70.38,147.9c-5.09-3.62-8.6-2-11-1.65a6.71,6.71,0,0,1-4.67-1.06,2.37,2.37,0,0,0-3.28.7,2.37,2.37,0,0,0,.7,3.28,21.14,21.14,0,0,0,5.8,2.34c-3.95,3.6-8,7.94-8.19,8.18a2.38,2.38,0,0,0,.13,3.36,2.37,2.37,0,0,0,1.61.63,2.34,2.34,0,0,0,1.74-.77s2.85-3.07,6-6.09c-2.9,3.64-5.63,7.42-6.13,8.12a2.37,2.37,0,0,0,.55,3.31,2.33,2.33,0,0,0,1.38.44,2.4,2.4,0,0,0,1.93-1c1.55-2.17,3.74-5.1,5.83-7.73-.78,1.54-1.76,3.28-3.74,6.47a2.37,2.37,0,0,0,.76,3.26,2.29,2.29,0,0,0,1.25.36,2.39,2.39,0,0,0,2-1.12c.81-1.31,1.47-2.39,2-3.33a2.36,2.36,0,0,0,.91,2.87,2.35,2.35,0,0,0,1.29.39,2.38,2.38,0,0,0,2-1.08,25.25,25.25,0,0,0,3.76-8.41l.1.07C-66.36,152.79-68,149.62-70.38,147.9Zm-4.76,16.69c.79-1.38,1.32-2.42,1.83-3.46A24.78,24.78,0,0,1-75.14,164.59Z",
    transform: "translate(186)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-7",
    d: "M-143,174.81c-7.52-.42-18.42,14.28-7.26,18.28-10.1-.24-12.57,14-3.31,18-16.21-3.15-14.33,17.85-6.66,25.45-5.2-.83-10.45,4.14-9.66,9.54s2.95,13,16.42,17,21.7-3.52,28.4-10.66c4.29,8.76,25.49-3.08,23.14-13.57,8,2.84,15.17-6.24,15.34-13.5.15-7.08-4.81-12.49-9.52-17.08,3.32-3.05,4-8.69,3.07-13-1.45-7.16-10.42-7.87-10.42-13.57,0-2,.39-8.19-1.31-10.92-2.71-4.33-7.42-8.61-13.34-6.5C-143,152.48-143,174.81-143,174.81Z",
    transform: "translate(186)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M-128.54,405.17c-6.85-1.19-8-.85-14.71-2.5l-15.66,19.14h60.74l-35.27-9.49Z",
    transform: "translate(186)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M-15.44,410.66-19,405.94a47.58,47.58,0,0,1-10.28,5.16l9.59,10.71H15.87Z",
    transform: "translate(186)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-7",
    d: "M-149.68,405.23c6.8,1.67,13.6,3.4,20.49,4.57L-79,348.1l-8.54-24.52-35.12-40.49,10.12,57.38Z",
    transform: "translate(186)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-8",
    d: "M-81.47,266.09c-13.76-3.65-32.42,1-45.81,6,0,0,8.21,32.7,13.61,42.45C-98,343-30.06,413.83-30.06,413.83c3.72-1.27,10.91-6.53,14.2-8.66Z",
    transform: "translate(186)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-10",
    d: "M-129.1,284.9c13.29-5,39.95-13.4,53.63-10,0,0-18.12-42.55-26.34-51.93-5.55-6.34-35.85-24.17-35.85-.86C-137.66,254.06-129.1,284.9-129.1,284.9Z",
    transform: "translate(186)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-15",
    d: "M-117.28,220.13a5.6,5.6,0,0,1-.54.17,7.59,7.59,0,0,1-9.31-5.35,45.55,45.55,0,0,1-1.2-10.11,7.59,7.59,0,0,1,7.56-7.62,7.6,7.6,0,0,1,7.63,7.55,30.49,30.49,0,0,0,.67,6.22A7.59,7.59,0,0,1-117.28,220.13Z",
    transform: "translate(186)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-16",
    d: "M-112.22,212.63a7.85,7.85,0,0,0-.25-1.64,30.49,30.49,0,0,1-.67-6.22,7.6,7.6,0,0,0-7.63-7.55,7.59,7.59,0,0,0-7.56,7.62c0,.1,0,.33,0,.65C-124.58,209.71-118.41,211.7-112.22,212.63Z",
    transform: "translate(186)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-3",
    d: "M-104.8,189.87A14.36,14.36,0,0,1-114,208h0a14.37,14.37,0,0,1-18.09-9.22l-3.08-9.48A14.36,14.36,0,0,1-126,171.17h0a14.36,14.36,0,0,1,18.09,9.22Z",
    transform: "translate(186)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-3",
    d: "M-20.25,182.25a2.28,2.28,0,0,0-1-.49l1.14-1.25a2.38,2.38,0,0,0-.13-3.36,3.37,3.37,0,0,0-.38-.28,2.37,2.37,0,0,0-.32-3.08,2.38,2.38,0,0,0-2.43-.49c1.08-1.09,1.76-1.85,1.84-1.94a2.37,2.37,0,0,0-.22-3.35,2.36,2.36,0,0,0-3.34.21c-.06.06-5.22,5.88-10.52,8.9a12.69,12.69,0,0,0-5.57-4.76,2.35,2.35,0,0,0-3,1.35,2.38,2.38,0,0,0,1.34,3.07,8.18,8.18,0,0,1,3.33,3,10.94,10.94,0,0,0-.55,2.2c-34.92,47.26-81.22,30.48-83.32,29.69a8.07,8.07,0,0,0-10.41,4.61,8.07,8.07,0,0,0,4.6,10.44,84,84,0,0,0,28.07,4.53,88.57,88.57,0,0,0,10.29-.59c17.43-2,43.21-12.07,63.81-38.61a16.64,16.64,0,0,0,1.45-.95,14.36,14.36,0,0,0,1.28-.94l-.05,0a36.67,36.67,0,0,0,4.43-4.51A2.37,2.37,0,0,0-20.25,182.25Z",
    transform: "translate(186)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-4",
    d: "M-84.52,211.77l-2,.43a70.35,70.35,0,0,1-14.75,1.56,65.27,65.27,0,0,1-21.67-3.44,9.44,9.44,0,0,0-3.4-.63,9.43,9.43,0,0,0-8.85,6.06A8.5,8.5,0,0,0-135,223c4.63,8.22,17.35,11.54,33.83,11.54A92.91,92.91,0,0,0-90.71,234c2.1-.25,4.31-.61,6.55-1.08l1.39-.36a56.75,56.75,0,0,1-2.4-12.08A72.75,72.75,0,0,1-84.52,211.77Z",
    transform: "translate(186)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-7",
    d: "M-135.5,196.88c5-3.17,6.7-9.1,6.16-15,4.37,2.94,7.82,1.14,10.55-3.9,8.28,11.6,20.9-5.66,3.69-11.91-13.76-5-27.25,8.61-23.72,22.29Z",
    transform: "translate(186)"
  }))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(Svg404);
export default __webpack_public_path__ + "static/media/404.614bb5f9b496a8a741bef542dee2023e.svg";
export { ForwardRef as ReactComponent };